import { render, staticRenderFns } from "./HeaderAdmin.vue?vue&type=template&id=4e628b00&scoped=true&"
import script from "./HeaderAdmin.vue?vue&type=script&lang=ts&"
export * from "./HeaderAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./HeaderAdmin.vue?vue&type=style&index=0&id=4e628b00&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e628b00",
  null
  
)

export default component.exports